export const L10N = {
  ACTION_SIGNOUT_CANCEL: { id: 'common.action.close' },

  BUTTON_SIGNOUT: { id: 'core.action.delete_account', defaultMessage: '　' },

  COUNTRY_LABEL: { id: 'core.label.country', defaultMessage: '　' },
  COUNTRY_PLACEHOLDER: { id: 'common.label.select' },
  CTA_SIGNOUT: { id: 'core.action.delete_account' },
  CTA_ACCOUNT: { id: 'core.action.save_info', defaultMessage: '　' },
  CTA_PASSWORD: { id: 'core.action.save_password', defaultMessage: '　' },
  CTA_SIGNUP: { id: 'core.action.signup_again' },

  DATEOFBIRTH_LABEL: { id: 'core.label.date_of_birth', defaultMessage: '　' },
  DATEOFBIRTH_ERROR: { id: 'core.label.date_of_birth_error' },
  DESCRIPTION_ACCOUNT: { id: 'core.label.description_account', defaultMessage: '　' },
  DESCRIPTION_PASSWORD: { id: 'core.label.description_password', defaultMessage: '　' },
  DESCRIPTION_SIGNOUT: { id: 'core.label.description_delete_account', defaultMessage: '　' },
  DESCRIPTION_SIGNOUT_MODAL: { id: 'core.label.modal_delete_account' },
  DESCRIPTION_SIGNOUT_MODAL_SUCCESS: { id: 'core.label.account_deleted' },

  EMAIL_LABEL: { id: 'common.label.email', defaultMessage: '　' },

  FIRSTNAME_LABEL: { id: 'common.label.name', defaultMessage: '　' },

  LASTNAME_LABEL: { id: 'common.label.lastname', defaultMessage: '　' },
  LABEL_REQUIRED: { id: 'common.label.required', defaultMessage: '　' },

  PASSWORD_LABEL: { id: 'common.label.password', defaultMessage: '　' },
  PASSWORD_HINT: { id: 'core.label.password_hint', defaultMessage: '　' },
  PASSWORD_NEW_LABEL: { id: 'common.label.new_password', defaultMessage: '　' },
  PASSWORD_NEW_CONFIRM_LABEL: { id: 'core.label.confirm_new_password', defaultMessage: '　' },

  SUBSCRIBED_LABEL: { id: 'core.label.subscribe', defaultMessage: '　' },

  TITLE_SIGNOUT: { id: 'core.label.delete_account', defaultMessage: '　' },

  // Notifications
  SUCCESS_ACCOUNT: { id: 'core.notification.update_success' },
  SUCCESS_PASSWORD: { id: 'core.notification.update_password_success' },
  SUCCESS_SIGNOUT: { id: 'core.notification.delete_account_success' },

  ERROR: { id: 'common.notification.network_error' },
  ERROR_PASSWORD: { id: 'common.notification.password_error' },

  LABEL_PERSONAL_DETAILS: { id: 'core.label.personal_details', defaultMessage: '　' },
  LABEL_SECURITY: { id: 'core.label.security', defaultMessage: '　' },
};
